<template>
  <div class="main_content" :class="{english:$i18n.locale=='en'}">
  <HeaderLine index="13" ref="dialog" showbar="true" @on-locale-change="onLocaleChange">
    {{$t('devolop.name')}}
  </HeaderLine>
   <div class="banner">
       <img :src="imglist[0]" alt="">    
   </div>
    <div class="main">
      <div class=" center " >
        <ul class="download_list main_wrap">
          <li class="download_list_item">
            <h3 class="download_item_title">{{$t('devolop.title2')}}</h3>
            <h4 class="download_item_title2">{{$t('devolop.title3')}}</h4>
            <ul class="download_platforms clearfix" style="padding-bottom: 0.7rem;">
               <li>
                 <h3 class="platform_name">{{$t('devolop.title4')}}</h3>
                 <p class="platform_info">{{$t('devolop.version1')}}</p>
                 <p class="platform_info" style="margin-bottom:0.4rem">{{$t('devolop.date1')}}</p>
                 <div >
                   <a href="https://github.com/vrviu-sdk/BitPlayer-SDK-Unity/blob/master/README.md" class="download_button1" target="_blank">{{$t('devolop.button1')}}</a>
                 </div>
                 <div>
                   <a href="https://github.com/vrviu-sdk/BitPlayer-SDK-Unity" class="download_button2" target="_blank">{{$t('devolop.button2')}}</a>
                 </div>
               </li>
               <li>
                 <h3 class="platform_name">{{$t('devolop.title55')}}</h3>
                 <p class="platform_info">{{$t('devolop.version2')}}</p>
                 <p class="platform_info" style="margin-bottom:0.4rem">{{$t('devolop.date2')}}</p>
                 <div >
                   <a href="https://github.com/vrviu-sdk/BitPlayer-SDK-Web/blob/master/README.md" class="download_button1" target="_blank">{{$t('devolop.button1')}}</a>
                 </div>
                 <div>
                   <a href="https://github.com/vrviu-sdk/BitPlayer-SDK-Web" class="download_button2" target="_blank">{{$t('devolop.button2')}}</a>
                 </div>
               </li>
            </ul>
          </li>
        </ul>
        <ul class="download_list main_wrap">
          <li class="download_list_item">
            <h3 class="download_item_title">{{$t('devolop.title5')}}</h3>
            <h4 class="download_item_title2">{{$t('devolop.title6')}}</h4>
            <ul class="download_platforms clearfix" style="padding-bottom: 1rem">
               <li>
                 <h3 class="platform_name">{{$t('devolop.title7')}}</h3>
                 <p class="platform_info">{{$t('devolop.version3')}}</p>
                 <p class="platform_info" style="margin-bottom:0.4rem">{{$t('devolop.date3')}}</p>
                 <div >
                   <a href="https://github.com/vrviu-sdk/AltPlayer-SDK-iOS/blob/master/README.md" class="download_button1" target="_blank">{{$t('devolop.button1')}}</a>
                 </div>
                 <div>
                   <a href="https://github.com/vrviu-sdk/AltPlayer-SDK-iOS" class="download_button2" target="_blank">{{$t('devolop.button2')}}</a>
                 </div>
               </li>
               <li>
                 <h3 class="platform_name">{{$t('devolop.title8')}}</h3>
                 <p class="platform_info">{{$t('devolop.Version4')}}</p>
                 <p class="platform_info" style="margin-bottom:0.4rem">{{$t('devolop.date4')}}</p>
                 <div >
                   <a href="https://github.com/vrviu-sdk/AltPlayer-SDK-Android/blob/master/README.md" class="download_button1" target="_blank">{{$t('devolop.button1')}}</a>
                 </div>
                 <div>
                   <a href="https://github.com/vrviu-sdk/AltPlayer-SDK-Android" target="_blank" class="download_button2">{{$t('devolop.button2')}}</a>
                 </div>
               </li>
               <li>
                 <h3 class="platform_name">{{$t('devolop.title9')}}</h3>
                 <p class="platform_info">{{$t('devolop.version5')}}</p>
                 <p class="platform_info" style="margin-bottom:0.4rem">{{$t('devolop.date5')}}</p>
                 <div >
                   <a href="https://github.com/vrviu-sdk/AltPlayer-SDK-Web/blob/master/README.md" class="download_button1" target="_blank">{{$t('devolop.button1')}}</a>
                 </div>
                 <div>
                   <a href="https://github.com/vrviu-sdk/AltPlayer-SDK-Web" class="download_button2" target="_blank">{{$t('devolop.button2')}}</a>
                 </div>
               </li>
            </ul>
          </li>
        </ul>
<!--         <div style="background:#e8f4ff">
         <ul class="download_list main_wrap">
            <li class="download_list_item">
              <h3 class="download_item_title">{{$t('devolop.title10')}}</h3>
              <h4 class="download_item_title2">{{$t('devolop.title11')}}</h4>
              <ul class="download_platforms clearfix">
                 <li>
                   <h3 class="platform_name">{{$t('devolop.title12')}}</h3>
                   <p class="platform_info">{{$t('devolop.version6')}}</p>
                   <p class="platform_info" style="margin-bottom:0.4rem">{{$t('devolop.date6')}}</p>

                   <div>
                     <a href="https://github.com/vrviu-sdk/VBS" class="download_button2" target="_blank">{{$t('devolop.button2')}}</a>
                   </div>
                 </li>
                 <li>
                   <h3 class="platform_name">{{$t('devolop.title13')}}</h3>
                   <p class="platform_info">{{$t('devolop.version7')}}</p>
                   <p class="platform_info" style="margin-bottom:0.4rem">{{$t('devolop.date7')}}</p>

                   <div>
                     <a href="https://github.com/vrviu-sdk/VBS/blob/master/VBSDemoPlayer.apk" target="_blank" class="download_button2">{{$t('devolop.button3')}}</a>
                   </div>
                 </li>
              </ul>
            </li>
          </ul>

        </div> -->
 
        <!-- <ul class="download_list main_wrap">
          <li class="download_list_item">
            <h3 class="download_item_title">{{$t('devolop.title14')}}</h3>
            <h4 class="download_item_title2">{{$t('devolop.title15')}}</h4>
            <ul class="download_platforms clearfix">
               <li>
                 <h3 class="platform_name" style="font-size:0.34rem">{{$t('devolop.title16')}}</h3>
                 <p class="platform_info">{{$t('devolop.Version8')}}</p>
                 <p class="platform_info" style="margin-bottom:0.4rem">{{$t('devolop.date8')}}</p>

                 <div>
                   <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.VRVIU.VrPlayer" class="download_button2" target="_blank">{{$t('devolop.button4')}}</a>
                 </div>
               </li>
               <li>
                 <h3 class="platform_name" style="font-size:0.34rem">{{$t('devolop.title17')}}</h3>
                 <p class="platform_info"></p>
                 <p class="platform_info" style="margin-bottom:0.88rem"></p>

                 <div>
                   <a href="javascript:void(0)" class="download_button2" style="background:#c5c5c5" target="_blank">{{$t('devolop.button5')}}</a>
                 </div>
               </li>
            </ul>
          </li>
        </ul> -->
      </div>
<!--       <div class=" center " v-if="$i18n.locale=='en'">
        <ul class="download_list main_wrap">
          <li class="download_list_item">
            <h3 class="download_item_title">VRVIU VR Player SDK</h3>
            <h4 class="download_item_title2">（VRVIU BitPlayer SDK）</h4>
            <ul class="download_platforms clearfix">
               <li>
                 <h3 class="platform_name">Unity</h3>
                 <p class="platform_info">Version：V2.1</p>
                 <p class="platform_info" style="margin-bottom:0.4rem">updated：2018.07.27</p>
                 <div >
                   <a href="https://github.com/vrviu-sdk/BitPlayer-SDK-Unity/blob/master/README.md" class="download_button1" target="_blank">Documentation</a>
                 </div>
                 <div>
                   <a href="https://github.com/vrviu-sdk/BitPlayer-SDK-Unity" class="download_button2" target="_blank">SDK download</a>
                 </div>
               </li>
               <li>
                 <h3 class="platform_name">HTML5</h3>
                 <p class="platform_info">Version：V1.0</p>
                 <p class="platform_info" style="margin-bottom:0.4rem">updated：2018.05.17</p>
                 <div >
                   <a href="https://github.com/vrviu-sdk/BitPlayer-SDK-Web/blob/master/README.md" class="download_button1" target="_blank">Documentation</a>
                 </div>
                 <div>
                   <a href="https://github.com/vrviu-sdk/BitPlayer-SDK-Web" class="download_button2" target="_blank">SDK download</a>
                 </div>
               </li>
            </ul>
          </li>
        </ul>
        <ul class="download_list main_wrap">
          <li class="download_list_item">
            <h3 class="download_item_title">High-Definition 2D Player SDK</h3>
            <h4 class="download_item_title2">（VRVIU AltPlayer SDK）</h4>
            <ul class="download_platforms clearfix">
               <li>
                 <h3 class="platform_name">iOS</h3>
                 <p class="platform_info">Version：V1.3</p>
                 <p class="platform_info" style="margin-bottom:0.4rem">updated：2018.04.19</p>
                 <div >
                   <a href="https://github.com/vrviu-sdk/AltPlayer-SDK-iOS/blob/master/README.md" class="download_button1" target="_blank">Documentation</a>
                 </div>
                 <div>
                   <a href="https://github.com/vrviu-sdk/AltPlayer-SDK-iOS" target="_blank" class="download_button2">SDK download</a>
                 </div>
               </li>
               <li>
                 <h3 class="platform_name">Android</h3>
                 <p class="platform_info">Version：V1.3</p>
                 <p class="platform_info" style="margin-bottom:0.4rem">updated：2018.04.28</p>
                 <div >
                   <a href="https://github.com/vrviu-sdk/AltPlayer-SDK-Android/blob/master/README.md" class="download_button1" target="_blank">Documentation</a>
                 </div>
                 <div>
                   <a href="https://github.com/vrviu-sdk/AltPlayer-SDK-Android" class="download_button2"target="_blank">SDK download</a>
                 </div>
               </li>
               <li>
                 <h3 class="platform_name">HTML5</h3>
                 <p class="platform_info">Version：V1.0</p>
                 <p class="platform_info" style="margin-bottom:0.4rem">updated：2018.05.07</p>
                 <div >
                   <a href="https://github.com/vrviu-sdk/AltPlayer-SDK-Web/blob/master/README.md" class="download_button1" target="_blank">Documentation</a>
                 </div>
                 <div>
                   <a href="https://github.com/vrviu-sdk/AltPlayer-SDK-Web" class="download_button2" target="_blank">SDK download</a>
                 </div>
               </li>
            </ul>
          </li>
        </ul>
        <div style="background:#e8f4ff">
         <ul class="download_list main_wrap">
            <li class="download_list_item">
              <h3 class="download_item_title">4K VR Personal Webcasts Software</h3>
              <h4 class="download_item_title2">（VBS）</h4>
              <ul class="download_platforms clearfix">
                 <li>
                   <h3 class="platform_name">Install on PC</h3>
                   <p class="platform_info">Version：V1.0</p>
                   <p class="platform_info" style="margin-bottom:0.4rem">updated：2018.05.11</p>

                   <div>
                     <a href=" https://github.com/vrviu-sdk/VBS" class="download_button2" target="_blank">Download</a>
                   </div>
                 </li>
                 <li>
                   <h3 class="platform_name">View on Android phone</h3>
                   <p class="platform_info">Version：Android V1.0</p>
                   <p class="platform_info" style="margin-bottom:0.4rem">updated：2018.05.04</p>

                   <div>
                     <a href="https://github.com/vrviu-sdk/VBS/blob/master/VBSDemoPlayer.apk" target="_blank" class="download_button2">Try now</a>
                   </div>
                 </li>
              </ul>
            </li>
          </ul>

        </div>
      
        <ul class="download_list main_wrap">
          <li class="download_list_item">
            <h3 class="download_item_title">LightVR APP</h3>
            <h4 class="download_item_title2">（Download to experience our quality 4K VR video streaming）</h4>

            <ul class="download_platforms clearfix">
               <li>
                 <h3 class="platform_name" style="font-size:0.34rem">Cardboard for Android</h3>
                 <p class="platform_info">Version：V1.2</p>
                 <p class="platform_info" style="margin-bottom:0.4rem">updated：2018.05.02</p>

                 <div>
                   <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.VRVIU.VrPlayer" class="download_button2" target="_blank">Download</a>
                 </div>
               </li>
               <li>
                 <h3 class="platform_name" style="font-size:0.34rem">Cardboard for iOS</h3>
                 <p class="platform_info"></p>
                 <p class="platform_info" style="margin-bottom:0.88rem"></p>

                 <div>
                   <a href="javascript:void(0)" class="download_button2" target="_blank" style="background:#c5c5c5">Coming Soon</a>
                 </div>
               </li>
            </ul>
          </li>
        </ul>
      </div> -->
    <Footerline></Footerline>
  </div>
</div>
</template>

<script>
import HeaderLine from './header.vue';
import Footerline from './footer.vue';

import '../common/css/devolop.css';
import Vue from 'vue'; 

import i18n from '../common/i18n'



  export default {
    name: 'about',
    i18n:i18n,
    data:function(){
      return{
       imglist:[
         "/static/images/devolop/banner.png",
         "/static/images/devolop/01.png",
         "/static/images/devolop/02.png",
         "/static/images/about/Brian.png",
         "/static/images/about/Tim.png",
         "/static/images/about/Joyce.png",
         "/static/images/about/Alen.png",
         "/static/images/about/bg.png"
       ]
      }
    },
　　watch:{

　　},
    mounted(){
      var language = navigator.language; //取得浏览器版本语言
      var initLanguage = "";
      if(localStorage.locale){
        this.$i18n.locale = localStorage.locale;
      }else{
        if (language.indexOf('zh') > -1){
          initLanguage="ch"; //中文页面
        }else if (language.indexOf('en') > -1){
          initLanguage="en"; //英文页面
        }
        this.$i18n.locale = initLanguage;
      }
    },
    computed: {

    },
    components:{
      HeaderLine,
      Footerline
    },
    methods:{
      onLocaleChange:function(val){
        this.$i18n.locale=val;
      }
    }
  }
</script>
<style scoped="">
.banner{
  height: 5rem;
}
  .download_platforms{
    width: 6.4rem;
    margin: 0 auto
  }
  .download_platforms li{
    width: auto!important;
    margin-right: 1.5rem!important
  }
  .download_platforms li:nth-child(3n){
    margin-top: 0.7rem
  }
  .platform_name, .platform_info{
    padding-left: 0!important
  }
.platform_name{
  font-size:0.32rem;
}
 .download_platforms li .platform_info{
  font-size: 0.24rem;
 }
</style>   


// WEBPACK FOOTER //
// devolop.vue?605ce9c8